import { apiServerUrl } from 'config/server';
import { expandApiServerHeader, prepareTokenPayload } from 'utils/mpt-session.helper';
import {
   ICreateIntentAndCustomerSessionResponse,
   ICreateIntentResponse,
   ISubmitStripeBillingPayload,
} from '../types/stripe.types';

const createIntentUrl = '/user/create-intent';
const createPaymentIntentUrl = '/user/create-payment-intent';
const createIntentAndCustomerSessionUrl = '/user/create-intent-and-customer-session';

const accountBilling = '/user/billing';

const prodUrls = {
   createIntent: `${apiServerUrl}${createIntentUrl}`,
   createPaymentIntent: `${apiServerUrl}${createPaymentIntentUrl}`,
   createIntentAndCustomerSession: `${apiServerUrl}${createIntentAndCustomerSessionUrl}`,
   billing: `${apiServerUrl}${accountBilling}`,
};

export function createStripeIntent() {
   return new Promise<ICreateIntentResponse>((resolve, reject) => {
      let requestOptions = {
         method: 'POST',
         headers: expandApiServerHeader(),
         body: JSON.stringify(prepareTokenPayload({})),
      };

      fetch(prodUrls.createIntent, process.env.REACT_APP_SERVER ? requestOptions : undefined)
         .then((response) => response.json())
         .then((resultData: ICreateIntentResponse) => {
            resolve(resultData);
         })
         .catch((err) => {
            reject(err);
         });
   });
}

export function addStripePaymentMethod(bodyInput: ISubmitStripeBillingPayload) {
   return new Promise((resolve, reject) => {
      const postData = {
         acctType: bodyInput.acctType,
         paymentMethod: bodyInput.paymentMethod,
         onCheckout: bodyInput.onCheckout,
      };

      let requestOptions = {
         method: 'POST',
         headers: expandApiServerHeader(),
         body: JSON.stringify(prepareTokenPayload(postData)),
      };

      fetch(`${prodUrls.billing}`, requestOptions)
         .then((response) => response.json())
         .then((resultData) => {
            resolve(resultData);
         })
         .catch((err) => {
            reject(err);
         });
   });
}

export function createIntentAndCustomerSession() {
   return new Promise<ICreateIntentAndCustomerSessionResponse>((resolve, reject) => {
      let requestOptions = {
         method: 'POST',
         headers: expandApiServerHeader(),
         body: JSON.stringify(prepareTokenPayload({})),
      };

      fetch(prodUrls.createIntentAndCustomerSession, process.env.REACT_APP_SERVER ? requestOptions : undefined)
         .then((response) => response.json())
         .then((resultData: ICreateIntentAndCustomerSessionResponse) => {
            resolve(resultData);
         })
         .catch((err) => {
            reject(err);
         });
   });
}

export function createStripePaymentIntent(amount: number) {
   return new Promise<ICreateIntentResponse>((resolve, reject) => {
      const postData = {
         amount,
      };
      let requestOptions = {
         method: 'POST',
         headers: expandApiServerHeader(),
         body: JSON.stringify(prepareTokenPayload(postData)),
      };

      fetch(prodUrls.createPaymentIntent, process.env.REACT_APP_SERVER ? requestOptions : undefined)
         .then((response) => response.json())
         .then((resultData: ICreateIntentResponse) => {
            resolve(resultData);
         })
         .catch((err) => {
            reject(err);
         });
   });
}
